<vs-empty-cart
  (emptycart)="receiveMessage($event)"
  [cartId]="cartId"
  *ngIf="(cartData$ | async) && cartStatus == 'empty'"
></vs-empty-cart
><vs-add-product
  [cartId]="cartId"
  (cancelAdding)="receiveMessage($event)"
  (productAdding)="refreshList($event)"
  [loaded]="false"
  *ngIf="(cartData$ | async) && cartStatus == 'adding'"
></vs-add-product>

  <div class="row m-0 background-shade" *ngIf="cartStatus == 'added'">
    <div class="col-md-2 add-button-container p-t-10">
      <button [disabled]="checkQuoteType && cartData?.totalItems > 3"
        class="vs-primary-btn add-button mt25"
        (click)="toggleAddProduct()"
      >
        <i *ngIf="closeAddProduct" class="material-icons">close</i>
        <i *ngIf="!closeAddProduct" class="material-icons">add</i>
        {{ "quoteCart.emptyCartButtonText" | cxTranslate }}
      </button>
    </div>
    <div class="col-md-7 p-t-10">
      <div class="row action-container">
        <div class="col-md-4">
          <div class="vs-text-field-date">
            <label class="ship-date label-custom"
              >{{ "quoteCart.customerRequestDateLabel" | cxTranslate }}
              <span class="star">*</span></label
            >
            <vs-date-picker
              class="date-picker-view-quote"
              *ngIf="cartData?.quoteCartType != QuoteStatus.EDIT"
              (selectedDate)="dateChange($event)"
              [defaultDate]="dateCheckAll.value"
              [min]="minDate"
              [filterWeekend]="filterWeekend"
            ></vs-date-picker>
            <vs-date-picker
              class="date-picker-view-quote disabled"
              *ngIf="cartData?.quoteCartType == QuoteStatus.EDIT"
              (selectedDate)="dateChange($event)"
              [defaultDate]="dateCheckAll.value"
              [min]="minDate"
              [filterWeekend]="filterWeekend"
            ></vs-date-picker>
          </div>
        </div>
        <div class="col-md-2">
          <button
            class="vs-tertiary-btn applyAllBtn"
            *ngIf="cartData?.quoteCartType != QuoteStatus.EDIT"
            (click)="applyDateToAll()"
            [disabled]="showAddProductLoader"
          >
            {{ "quoteCart.applyToAll" | cxTranslate }}
            <div
              *ngIf="showAddProductLoader"
              class="availability-spinner float-right cx-spinner"
            >
              <cx-spinner></cx-spinner>
            </div>
          </button>
          <button
            class="vs-tertiary-btn applyAllBtn disabled"
            *ngIf="cartData?.quoteCartType == QuoteStatus.EDIT"
            [disabled]="
              cartData?.quoteCartType == QuoteStatus.EDIT ? true : false
            "
            (click)="applyDateToAll()"
          >
            {{ "quoteCart.applyToAll" | cxTranslate }}
          </button>
        </div>
        <div class="col-md-6">
          <!-- <label class="quote-type label-custom">{{ "quoteCart.quoteType" | cxTranslate }}
            <i class="material-icons quote-info" matTooltipClass="vs-tooltip" matTooltipPosition="right"
            matTooltip='{{ "quoteCart.fastTrackQuoteNote" | cxTranslate }}'>info</i>
          </label>
          <div class="vs-checkbox check-all-holder pl-2">
            <input
              id="check-quote-type"
              type="checkbox"
              value="true"
              name="check-quote-type"
              
              (click)="checkQuoteEntries($event,cartData.entries)"
              
            />
            <label for="check-quote-type" class="fast-track-label">{{ "quoteCart.fastTrack" | cxTranslate }}
              <span class="charges-apply">({{ "quoteCart.chargesApply" | cxTranslate }})</span></label>
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-md-3 text-right text-btn">
      <div class="summary-details" *ngIf="checkQuoteType">
        <ng-container *ngIf="fastTrackData$ | async as fastTrack">
        <div class="sub-total">
          <span class="heading-text float-left">{{ "quoteCart.quoteFee" | cxTranslate }}</span>
          <span class="float-right content-bold">{{fastTrack.price?.currencyIso}} {{fastTrack.price.formattedValue}}</span>
        </div>
        <div class="surcharge">
          <span class="heading-text float-left" >{{ "quoteCart.surcharge" | cxTranslate }}</span>
          <span class="float-right content-bold">{{ fastTrack.price?.currencyIso }}
            {{0 | currency: fastTrack.price?.currencyIso :"symbol-narrow"}}</span>
        </div>
        <div class="quote-price-summary" >
          <span class="float-left">{{ "quoteCart.cartTotal" | cxTranslate }} (
            {{ cartData?.totalItems }} {{ "quoteCart.items" | cxTranslate }} ) : </span>
          <span class="float-right">{{fastTrack.price.currencyIso}} {{fastTrack.price.formattedValue}}</span>
        </div>
        <div class="quote-billable-note" >
          <span class="float-left">({{ "quoteCart.billableOnOrder" | cxTranslate }})
            <i class='material-icons' matTooltipClass="vs-tooltip" matTooltip="Message" matTooltipPosition="above">info</i>
          </span>
          <!-- <span class="float-right">USD $250.00</span> -->
        </div>
      </ng-container>
        <div class="quote-summary-actions">
          <button [disabled]="(checkQuoteType && cartData?.totalItems > 3) || (checkQuoteType && partPlaceholderFlag)" (click)="viewCheckout()" class="vs-primary-btn checkoutBtn">
            {{ "quoteCart.checkout" | cxTranslate }}
          </button>
        </div>
      </div> 
      <p class="m-b-5 m-r-15" *ngIf="!checkQuoteType">
        <span class="header" *ngIf="cartData?.totalItems <= 1"
          >{{ "quoteCart.cartTotal" | cxTranslate }} (
          {{ cartData?.totalItems }}  {{ "quoteCart.item" | cxTranslate }} ) :
        </span>
        <span class="header" *ngIf="cartData?.totalItems > 1"
          >{{ "quoteCart.cartTotal" | cxTranslate }} (
          {{ cartData?.totalItems }}  {{ "quoteCart.items" | cxTranslate }} ) :
        </span>
        <span class="bold">
          {{ "quoteCart.toBeQuoted" | cxTranslate }}
        </span>
        <button (click)="viewCheckout()" class="vs-primary-btn checkoutBtn">
          {{ "quoteCart.checkout" | cxTranslate }}
        </button>
      </p>
    </div>
  </div>

<div class="container-fluid p-l-r" *ngIf="cartStatus == 'added'">
  <div *ngIf="closeAddProduct" class="add-product-show">
    <vs-add-product
      (productAdding)="productAddedInLoadedCart($event)"
      [defaultRequestedDate]="defaultRequestedDate"
      (cancelAddingLoaded)="cancelAddingLoaded($event)"
      [loaded]="true"
    >
    </vs-add-product>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="row cart-action-container">
        <div class="action-left">
          <div class="vs-checkbox check-all-holder pl-2">
            <input
              id="check-all"
              type="checkbox"
              value="true"
              name="check-all"
              [(ngModel)]="checkAll"
              (click)="checkAllEntries($event,cartData.entries)"
              
            />
            <label for="check-all" class="cart-item-check"></label>
          </div>

          <span>
            <a
              class="action-links"
              (click)="openDeleteAllPopUp(false)"
            >
              <i class="material-icons-outlined delete"> delete </i>
              <span>{{ "quoteCart.delete" | cxTranslate }}</span>
            </a>
          </span>
        </div>
        <div class="action-right">
          <div class="p-0-align mr-42">
            <a class="action-links"
              (click)="openDeleteAllPopUp(true)">
              <em class="material-icons-outlined">delete</em>
              <span>{{ "quoteCart.clearCart" | cxTranslate }}</span>
              </a>
          </div>
          <div class="p-0-align mr-42" *ngIf="userType == 'current'">
            <a class="action-links" (click)="downloadXLS()">
              <em class="material-icons-outlined"> cloud_download </em>
              <span>{{ "quoteCart.downloadXLS" | cxTranslate }}</span>
            </a>
          </div>
          <div class="p-0-align mr-2" *ngIf="userType == 'current'">
            <a  class="action-links" (click)="openSaveCartModal()">
              <em class="material-icons-outlined">save</em>
              <span>{{ "quoteCart.saveCart" | cxTranslate }}</span>
            </a>
          </div>
          <!-- <span>
            <a
              class="action-links"
              (click)="openDeleteAllPopUp(false)"
            >
              <i class="material-icons delete mr-2"> delete </i>
              <span>Delete</span>
            </a>
          </span> -->
        </div>
        
      </div>
      <mat-accordion multi>
        <mat-expansion-panel [expanded]="true" disabled>
          <mat-expansion-panel-header
            (click)="toggleButton()"
            class="accordtion-header bdr-btm"
          >
            <div class="row">
              <div class="col-md-2">
                <span>#</span>
                <span class="prodcutImg">{{
                  "quoteCart.product" | cxTranslate
                }}</span>
              </div>
              <div class="col-md-3"></div>
              <div class="col-md-2">
                {{ "quoteCart.quantityLabel" | cxTranslate }}
              </div>
              <div class="col-md-2">{{ "quoteCart.price" | cxTranslate }}</div>
              <div class="col-md-2">
                {{ "quoteCart.additionalDetail" | cxTranslate }}
              </div>
              <div class="col-md-1 right expandAll">
                <a class="panel-head">
                  <span *ngIf="!showToggle">{{ "quoteCart.expandAllBtn" | cxTranslate }}<i  class="material-icons">
                    keyboard_arrow_down
                  </i></span>
                  <span *ngIf="showToggle">{{ "quoteCart.collapseAllBtn" | cxTranslate }}<i  class="material-icons">
                    keyboard_arrow_up
                  </i></span>
                  <!-- <i *ngIf="showToggle" class="material-icons">
                    keyboard_arrow_up
                  </i> -->
                  <!-- <i *ngIf="!showToggle" class="material-icons">
                    keyboard_arrow_down
                  </i> -->
                </a>
              </div>
            </div>
          </mat-expansion-panel-header>

          <div *ngIf="cartData">
            <div *ngFor="let product of cartData?.entries; let i = index">
              <vs-quote-cart-product
                [product]="product"
                [customerRequestedDate]="dateAll"
                [productOpen]="showToggle"
                [reasonForQuotes]="reasonForQuote"
                (deleteProductFromList)="deleteProductFromList($event)"
                (deleteLoading)="deleteLoading($event)"
                (refreshQtyList)="getCartForQty()"
                (refreshList)="refreshList($event)"
                [brands]="brandList"
                [cartProductsList]="productData"
                [entryNum]="i"
                [checkAll]="checkAll"
                (selectedEntry)="onEntryCheck($event)"
              ></vs-quote-cart-product>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="row mb40 m-t-20">
        <div class="col-md-9"></div>
        <div class="col-md-3 text-right text-btn">
          <p class="m-b-5 m-r-15">
            <span class="header" *ngIf="cartData?.totalItems <= 1"
              >{{ "quoteCart.cartTotal" | cxTranslate }} (
              {{ cartData?.totalItems }}  {{ "quoteCart.item" | cxTranslate }} ) :
            </span>
            <span class="header" *ngIf="cartData?.totalItems > 1"
              >{{ "quoteCart.cartTotal" | cxTranslate }} (
              {{ cartData?.totalItems }}  {{ "quoteCart.items" | cxTranslate }} ) :
            </span>
            <span class="bold">
              {{ "quoteCart.toBeQuoted" | cxTranslate }}
            </span>
            <!-- <span *ngIf="!checkForObsoleteProducts(cartData) && cartData.totalPrice.formattedValue && userType === 'current' && showPrice" class="content"> 
              {{ cartData.totalPrice.currencyIso }}
              {{ cartData.totalPrice.formattedValue }}
            </span>
            <span *ngIf="(checkForObsoleteProducts(cartData) || !cartData.totalPrice.formattedValue || !cartData.totalPrice.value || cartData.totalPrice.value < 0 || userType === 'anonymous' || !showPrice)" class="bold">
              {{ "quoteCart.toBeQuoted" | cxTranslate }}
            </span> -->
          </p>
          <button [disabled]="(checkQuoteType && cartData?.totalItems > 3) || (checkQuoteType && partPlaceholderFlag)" 
            (click)="viewCheckout()" class="vs-primary-btn checkoutBtn">
            {{ "quoteCart.checkout" | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
